import React, { useState } from "react";
import {
  Select,
  DatePicker,
  Button,
  message,
  Result,
  Input,
  Radio,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { SearchOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { dateStringToEpoch } from "../../utils/utility";
import citiesActions from "../../redux/cities/actions";
import schedulesActions from "../../redux/schedules/actions";
import destinationActions from "../../redux/destinationForm/actions";
import mainActions from "../../redux/main/actions";
import {
  bulgarianLocaleDaysAndMonths,
  bulgarianLocalCalandarText,
} from "../../utils/utility";
import "./index.css";
const { Option } = Select;

const DestinationForm = () => {
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setChooseDestinationText } = mainActions;
  const { getTripToCities } = citiesActions;
  const { getSchedules, setUnlockSchedulesPage, getSchedulesTwoWay } =
    schedulesActions;
  const {
    setDestinationFrom,
    setDestinationTo,
    setDestinationDate,
    setDestinationDateTwoWay,
    setShowTwoWayDateInput,
  } = destinationActions;
  const { token, companies, selectedLanguage } = useSelector(
    (state) => state.mainReducer
  );
  const { cities, tripToCity } = useSelector((state) => state.citiesReducer);
  const {
    destinationFrom,
    destinationTo,
    destinationDate,
    destinationDateTwoWay,
    showTwoWayDateInput,
  } = useSelector((state) => state.destinationReducer);

  const [checkEmptyDestinationInput, setCheckEmptyDestinationInput] =
    useState(false);
  const [fillEmptyMessageApi, emptyMessageHolder] = message.useMessage();
  const [startPlusButtonAnimation, setStartPlusButtonAnimation] =
    useState(false);
  const [startMinusButtonAnimation, setStartMinusButtonAnimation] =
    useState(false);

  const [searchValueFrom, setSearchValueFrom] = useState("");
  const [searchValueTo, setSearchValueTo] = useState("");

  const displayEmptyInputsError = () => {
    fillEmptyMessageApi.open({
      type: "error",
      content: (
        <span className="remove-pointer-events">{t("fillEmptyFields")}</span>
      ),
    });
  };

  const getSchedulesRequest = () => {
    setCheckEmptyDestinationInput(true);
    if (destinationDate && destinationFrom && destinationTo) {
      dispatch(
        getSchedules(
          token,
          companies[0].id,
          destinationFrom,
          destinationTo,
          dateStringToEpoch(destinationDate.format("DD/MM/YYYY HH:mm"))
        )
      );

      dispatch(
        getSchedulesTwoWay(
          token,
          companies[0].id,
          destinationTo,
          destinationFrom,
          dateStringToEpoch(destinationDateTwoWay.format("DD/MM/YYYY HH:mm"))
        )
      );

      dispatch(setUnlockSchedulesPage(true));
      dispatch(setChooseDestinationText(false));
      if (pathname !== "/schedules") {
        navigate("/schedules");
      }
      //Scroll to Schedules in mobile view
      if (window.innerWidth < 820) {
        setTimeout(() => {
          const scrollToSchedule =
            document.getElementById("scroll-to-schedule");
          const scrollToNoSchedule =
            document.getElementById("scrollToNoSchedule");

          if (scrollToSchedule) {
            scrollToSchedule.scrollIntoView({ behavior: "smooth" });
          }
          if (scrollToNoSchedule) {
            scrollToNoSchedule.scrollIntoView({ behavior: "smooth" });
          }
        }, 500);
      }
    } else {
      displayEmptyInputsError();
    }
  };

  const citiesOptions = (array) => {
    return array.map((city) => {
      return {
        value: city.id,
        label: selectedLanguage === "bg" ? city?.name : city?.nameLat,
      };
    });
  };

  const getFromDestinationValue = (value) => {
    dispatch(setDestinationFrom(value));
  };

  const getToDestinationValue = (value) => {
    dispatch(setDestinationTo(value));
  };

  const getDestinationDate = (date, dateString) => {
    dispatch(setDestinationDate(date));
    if (destinationFrom) {
      dispatch(
        getTripToCities(
          token,
          companies[0]?.id,
          destinationFrom,
          dateStringToEpoch(date.format("DD/MM/YYYY HH:mm"))
        )
      );
    }
  };

  const incrementDate = () => {
    setStartPlusButtonAnimation(true);

    const plusOneDay = destinationDate.add(1, "day");
    dispatch(setDestinationDate(plusOneDay));
    if (destinationFrom) {
      dispatch(
        getTripToCities(
          token,
          companies[0]?.id,
          destinationFrom,
          dateStringToEpoch(plusOneDay.format("DD/MM/YYYY HH:mm"))
        )
      );
    }
  };
  const animationEndPlusButton = () => {
    setStartPlusButtonAnimation(false);
  };

  const decrementDate = () => {
    setStartMinusButtonAnimation(true);
    const minusOneDay = destinationDate.subtract(1, "day");
    dispatch(setDestinationDate(minusOneDay));
    if (destinationFrom) {
      dispatch(
        getTripToCities(
          token,
          companies[0]?.id,
          destinationFrom,
          dateStringToEpoch(minusOneDay.format("DD/MM/YYYY HH:mm"))
        )
      );
    }
  };

  const animationEndMinusButton = () => {
    setStartMinusButtonAnimation(false);
  };

  const getTripToCity = (value) => {
    getFromDestinationValue(value);
    if (value) {
      dispatch(
        getTripToCities(
          token,
          companies[0]?.id,
          value,
          dateStringToEpoch(destinationDate.format("DD/MM/YYYY HH:mm"))
        )
      );
    }
  };
  const handleGetSearchFromValue = (value) => {
    setSearchValueFrom(value);
  };

  const handleGetSearchToValue = (value) => {
    setSearchValueTo(value);
  };

  const searchDestinationFrom = (searchedValue, getSearchedValue) => (
    <Input
      variant="borderless"
      placeholder={t("search")}
      value={searchedValue}
      onChange={(e) => getSearchedValue(e.target.value)}
    />
  );

  const filteredCities = (cityArray, searchedValue) => {
    return cityArray.filter((city) =>
      selectedLanguage === "bg"
        ? city?.name?.toLowerCase()?.includes(searchedValue?.toLowerCase())
        : city?.nameLat?.toLowerCase()?.includes(searchedValue?.toLowerCase())
    );
  };

  return (
    <>
      {emptyMessageHolder}
      <div style={{ marginBottom: "10px", zIndex: "2" }}>
        <Radio.Group
          value={showTwoWayDateInput}
          onChange={(e) => dispatch(setShowTwoWayDateInput(e.target.value))}
          size="large"
          name="radiogroup"
          defaultValue={false}
          options={[
            {
              value: false,
              label: (
                <p style={{ color: "#fff", fontSize: "18px" }}>{t("oneWay")}</p>
              ),
            },
            {
              value: true,
              label: (
                <p style={{ color: "#fff", fontSize: "18px" }}>{t("twoWay")}</p>
              ),
            },
          ]}
        />
      </div>
      <div className="destination-form-container">
        {showTwoWayDateInput ? (
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{
                  marginBottom: "5px",
                  fontSize: "13px",
                  color: "#fff",
                  zIndex: "9999",
                }}
              >
                {t("departureDate")}
              </label>
              <DatePicker
                allowClear={false}
                inputReadOnly={true}
                minDate={dayjs()}
                showNow={false}
                style={{
                  height: "50px",
                  width: "100%",
                  borderRadius: "0",
                  borderTopLeftRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
                format="DD/MM/YYYY"
                value={destinationDate}
                onChange={(date) => getDestinationDate(date)}
                disabledDate={(current) =>
                  current && current.isBefore(dayjs(), "day")
                }
                locale={{
                  lang: bulgarianLocalCalandarText,
                  dayjsLocale: bulgarianLocaleDaysAndMonths,
                }}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <label
                style={{
                  marginBottom: "5px",
                  fontSize: "13px",
                  color: "#fff",
                  zIndex: "9999",
                }}
              >
                {t("returnDate")}
              </label>
              <DatePicker
                allowClear={false}
                inputReadOnly={true}
                minDate={dayjs()}
                showNow={false}
                style={{
                  height: "50px",
                  width: "100%",
                  borderRadius: "0",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                }}
                format="DD/MM/YYYY"
                value={destinationDateTwoWay}
                onChange={(date) => dispatch(setDestinationDateTwoWay(date))}
                disabledDate={(current) =>
                  current && current.isBefore(destinationDate, "day")
                }
                locale={{
                  lang: bulgarianLocalCalandarText,
                  dayjsLocale: bulgarianLocaleDaysAndMonths,
                }}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                marginBottom: "5px",
                fontSize: "13px",
                color: "#fff",
                zIndex: "9999",
              }}
            >
              {t("departureDate")}
            </label>
            <div className="destination-form-date-picker-container">
              <Button
                className={
                  startMinusButtonAnimation
                    ? "destination-form-change-date-button-minus clicked"
                    : "destination-form-change-date-button-minus"
                }
                size="large"
                onClick={decrementDate}
                disabled={destinationDate <= dayjs() ? true : false}
                onAnimationEnd={animationEndMinusButton}
              >
                <MinusOutlined className="destination-form-change-date-button-icon" />
              </Button>

              <div className="destination-form-datepicker-container">
                <DatePicker
                  allowClear={false}
                  inputReadOnly={true}
                  minDate={dayjs()}
                  value={destinationDate}
                  showNow={false}
                  className="destination-form-items-datepicker"
                  size="large"
                  format="DD/MM/YYYY"
                  onChange={getDestinationDate}
                  placeholder={t("date")}
                  locale={{
                    lang: bulgarianLocalCalandarText,
                    dayjsLocale: bulgarianLocaleDaysAndMonths,
                  }}
                />
              </div>

              <Button
                className={
                  startPlusButtonAnimation
                    ? "destination-form-change-date-button-plus clicked"
                    : "destination-form-change-date-button-plus"
                }
                size="large"
                onClick={incrementDate}
                onAnimationEnd={animationEndPlusButton}
              >
                <PlusOutlined className="destination-form-change-date-button-icon" />
              </Button>
            </div>
          </div>
        )}
        <Select
          dropdownRender={(menu) => (
            <div>
              {searchDestinationFrom(searchValueFrom, handleGetSearchFromValue)}
              {menu}
            </div>
          )}
          value={destinationFrom || undefined}
          status={
            checkEmptyDestinationInput &&
            (destinationFrom?.length === 0 || destinationFrom === undefined) &&
            "error"
          }
          size="large"
          className="destination-form-items"
          onChange={(value) => {
            getTripToCity(value);
          }}
          placeholder={t("from")}
          notFoundContent={
            <Result
              icon={null}
              title={
                <p className="destination-form-select-empty-title remove-pointer-events">
                  {t("notFoundCities")}
                </p>
              }
            />
          }
        >
          {citiesOptions(filteredCities(cities, searchValueFrom)).map(
            (option) => (
              <Option
                key={option.value}
                value={option.value}
                label={option.label}
              >
                <span className="destination-form-select-option remove-pointer-events">
                  {option.label}
                </span>
              </Option>
            )
          )}
        </Select>

        <Select
          value={destinationTo || undefined}
          dropdownRender={(menu) => (
            <div>
              {searchDestinationFrom(searchValueTo, handleGetSearchToValue)}
              {menu}
            </div>
          )}
          status={
            checkEmptyDestinationInput &&
            (destinationTo?.length === 0 || destinationTo === undefined) &&
            "error"
          }
          size="large"
          className="destination-form-items"
          onChange={getToDestinationValue}
          placeholder={t("to")}
          notFoundContent={
            <Result
              icon={null}
              title={
                <p className="destination-form-select-empty-title remove-pointer-events">
                  {t("notFoundCities")}
                </p>
              }
            />
          }
        >
          {citiesOptions(filteredCities(tripToCity, searchValueTo)).map(
            (option) => (
              <Option
                key={option.value}
                value={option.value}
                label={option.label}
              >
                <span className="destination-form-select-option remove-pointer-events">
                  {option.label}
                </span>
              </Option>
            )
          )}
        </Select>
        <Button
          icon={<SearchOutlined />}
          size="large"
          type="primary"
          className="destination-form-button custom-button"
          onClick={() => {
            getSchedulesRequest();
          }}
        >
          <span className="remove-pointer-events">{t("search")}</span>
        </Button>
      </div>
    </>
  );
};

export default DestinationForm;
